import { ErrorBoundary } from '@/components/ErrorBoundary';
import { UpdatePrompt } from '@/components/UpdatePrompt';
import { GlobalStyles } from '@/design/globalStyles';
import { AuthProvider } from '@/features/auth/AuthProvider';
import { queryClient } from '@/lib/queryClient';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

export function Providers({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <GlobalStyles />
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          {children}
          <UpdatePrompt />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
